/* eslint-disable @reatom/unit-naming-rule */
import { action, atom } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { currencyRegistry } from '@root/entities/currency/atoms'
import { premiumMetaRegistry, type PremiumId } from '@root/entities/premium'
import { Socials } from '@root/entities/socials'
import { refreshUserPremiumsAction } from '@root/features/premium'
import { updatePremiumCurrencyRequestAction } from '@root/features/premium/update-currency'
import { reatomRequest } from '@root/shared/lib'
import { showSnackbarAction } from '@root/shared/ui-kit'

import type { CurrencyAddress } from '@root/entities/currency'
import type { Network } from '@root/entities/network'

export const premiumCurrencyDialogAtom = atom<CurrencyAddress | undefined>(
  undefined,
  'premiumCurrencyDialogAtom',
)

type SubmitValues = {
  readonly websiteUrl: string
  readonly telegramUrl: string
  readonly xUrl: string
}

export const reatomPremiumCurrencySocialLinksForm = (options: {
  premiumId: PremiumId
  currencyAddress: CurrencyAddress
  network: Network.Network
}) => {
  const execAction = action(async (ctx, submitValues: SubmitValues) => {
    const result = await ctx.schedule(() =>
      updatePremiumCurrencyRequestAction(ctx, {
        premiumId: options.premiumId,
        network: options.network,
        currencyAddress: options.currencyAddress,
        socials: {
          ...Socials.empty(),
          x: submitValues.xUrl,
          website: submitValues.websiteUrl,
          telegram: submitValues.telegramUrl,
          discord: undefined,
        },
      }),
    )

    return result.pipe(
      Result.map((it) => {
        const currency = currencyRegistry.resolveFromTokenMeta(ctx, it.currency)
        return {
          currency: currency,
          premiumMeta: premiumMetaRegistry.resolve(ctx, {
            dto: it.premium,
            currency: currency,
          }),
        }
      }),
    )
  })
  const formSubmitStateAtom = reatomRequest({
    execAction: execAction,
    name: 'premiumCurrencySocialLinksFormSubmitState',
    onResult: (ctx, result) => {
      if (Result.isFailure(result)) {
        showSnackbarAction(ctx, {
          text: i18next.t('common.something-went-wrong'),
          intent: 'error',
        })
        return
      }

      showSnackbarAction(ctx, {
        text: i18next.t('premium.update-links.updated'),
        intent: 'success',
      })

      refreshUserPremiumsAction(ctx)
    },
  })

  return { formSubmitStateAtom }
}
